function showProdDetails(ele) {
  let parentDiv = ele.closest(".card__inner_custom");
  let infoBlock = parentDiv.querySelector(".card__content_custom");

  let showDetailsBlocks = document.querySelectorAll(".show_details");

  showDetailsBlocks.forEach((block) => {
    block.classList.remove("show_details");
    block.classList.add("hide_details");
    block
      .closest(".card_custom")
      .querySelector(".btn_show_details").style.display = "grid";
  });

  infoBlock.classList.remove("hide_details");
  infoBlock.classList.add("show_details");
  ele.style.display = "none";

  const screenWidth = window.matchMedia("(max-width: 600px)").matches;

  if (screenWidth) {
    let mobBackground = document.querySelectorAll(".bg-mobile");
    mobBackground.forEach((block) => {
      block.style.display = "none";
    });

    parentDiv.querySelector(".bg-mobile").style.display = "block";
  }

  let errorMsgBox = parentDiv.querySelector('.custom-product-form__error-message-wrapper .custom-product-form__error-message');
  
  if(errorMsgBox.textContent !== ""){
    errorMsgBox.textContent = "";
  }
}

function hideDetailsMob(ele) {
  let parent = ele.closest(".card__inner_custom");
  let infoBlock = parent.querySelector(".card__content_custom");
  infoBlock.classList.add("hide_details");
  infoBlock.classList.remove("show_details");
  parent.querySelector(".btn_show_details").style.display = "grid";
  ele.style.display = "none";
}

function sendData(ele) {
  let var_id = ele.getAttribute("data-varId");
  let prod_id = ele.getAttribute("data-prodId");
  let variant_value = ele.getAttribute("data-varValue");
  let variant_name = ele.getAttribute("data-varName");
  let containingDiv = ele.closest(".card__content_custom");


  let hiddenInput = containingDiv.querySelector("input.product-variant-id");
  hiddenInput.value = var_id;
  containingDiv.querySelector("input[name=product-id]").value = prod_id;

  //check variant inventory

  let variables = {
    productId: "gid://shopify/Product/" + prod_id
  };

  const myHeaders = new Headers();
  myHeaders.append(
    "X-Shopify-Storefront-Access-Token",
    "f4f9d7f113c1eceb58a2c5cea8a11f01"
  );
  myHeaders.append("Content-Type", "application/json");

  const graphql = JSON.stringify({
    query:
      "query GetProduct($productId: ID!) \r\n{\r\n  product(id: $productId) {\r\n    variants(first: 30) {\r\n      nodes {\r\n        id\r\n        quantityAvailable\r\n      }\r\n    }\r\n  }\r\n}",
    variables: variables,
  });
  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: graphql,
    redirect: "follow",
  };


  fetch(
    "https://theshop-america.myshopify.com/api/2024-01/graphql.json",
    requestOptions
  )
    .then((response) => response.json())
    .then((result) => {

      let varArray = result.data.product.variants.nodes;

      if (varArray.length > 0) {
        let matchedVariant = varArray.find((variant) => {
          varIdFetched = variant.id.replace(
            "gid://shopify/ProductVariant/",
            ""
          );
          return varIdFetched === var_id;
        });
        if (matchedVariant) {
          let quantityAvailable = matchedVariant.quantityAvailable;
          if (quantityAvailable > 0) {
            containingDiv.querySelector("button.product-form__submit").click();
          } else {
            alert(" {{- 'products.product.inventory_out_of_stock' | t -}}");
          }
        }
      }
    })
    .catch((error) => console.error(error));
}
